<template>
  <div>
    <progress-label :status="status" v-if="!trackInfo || Object.keys(trackInfo).length === 0"></progress-label>
    <div class="wrapper" v-if="trackInfo && Object.keys(trackInfo).length > 0">
      <loading name="lp" :active.sync="isLoading" :can-cancel="true" :is-full-page="true"></loading>
      <notifications></notifications>
      <div class="main-div">
        <div class="header">
          <h3 class="title">Sığorta hadisəsi</h3>
        </div>
        <div class="info-section">
          <h4 class="section-title">
            <md-button class="md-info md-icon md-sm md-simple">
              <md-icon class="custom-icon">task</md-icon>
            </md-button>
            Hadisə məlumatı
          </h4>
          <div class="info-item">
            <label>Zəng vaxtı</label>
            <span>{{ trackInfo.callDate }}</span>
          </div>
          <div class="info-item">
            <label>Hadisə vaxtı</label>
            <span>{{ trackInfo.accidentDate }}</span>
          </div>
          <div class="info-item">
            <label>SŞ</label>
            <span>{{ trackInfo.policyNumber }}</span>
          </div>
          <div class="info-item">
            <label>Zərər növü</label>
            <span>{{ trackInfo.damageTypeName }}</span>
          </div>
          <div class="info-item">
            <label>Hadisə səbəbi</label>
            <span>{{ trackInfo.damageCategoryName }}</span>
          </div>
          <div class="info-item">
            <label>F4 statusu</label>
            <span v-if="trackInfo.form4Status == 0" style="color:red;">F4 Göndərilməyib</span>
            <span v-else>F4 göndərilib</span>
          </div>
          <div class="info-item">
            <label>Sığorta müddəti</label>
            <span v-if='voluntaryPeriod !== "null-null"'>{{ voluntaryPeriod }} (Kasko(könüllü))</span>
            <span v-if='compulsoryPeriod !== "null-null"'>{{ compulsoryPeriod }} (İcbari)</span>
            <!-- <span>19.08.2023 23:29 - 19.08.2024 23:29</span> -->
          </div>

          <div class="info-item">
            <label>Hadisə yeri</label>
            <div class="info-content">
              <span class="info-text">{{ trackInfo.place }}</span>
              <md-button class="btn-maps md-sm" @click="mapsSelector">
                <md-icon>location_on</md-icon>XƏRİTƏ
              </md-button>
            </div>
          </div>
        </div>
        <div class="car-section">
          <div class="car-info">
            <h4 class="section-title">
              <md-button class="md-info md-icon md-sm md-simple">
                <md-icon class="custom-icon">time_to_leave</md-icon>
              </md-button>
              Zərərvuran
            </h4>
            <div>
              <plate :value="formatPlateNumber(trackInfo.insuredRegNumber)" />
            </div>
            <div class="info-item">
              <label>A.S.A :</label>
              <span> {{ trackInfo.insuredName }}</span>
            </div>
            <div class="info-item">
              <label>Marka model :</label>
              <span v-if="trackInfo.insuredBrandName && trackInfo.insuredModelName">{{ trackInfo.insuredBrandName }} {{
                trackInfo.insuredModelName }}</span>
              <span v-else>{{ trackInfo.insuredCustomBrandModel }}</span>
            </div>
          </div>
          <div class="car-info">
            <h4 class="section-title">
              <md-button class="md-info md-icon md-sm md-simple">
                <md-icon class="custom-icon">local_car_wash</md-icon>
              </md-button>
              Zərərçəkən
            </h4>
            <div>
              <plate :value="formatPlateNumber(trackInfo.osRegNumber)" />
            </div>
            <div class="info-item">
              <label>A.S.A :</label>
              <span> {{ trackInfo.osPartPersonName }}</span>
            </div>
            <div class="info-item">
              <label>Marka model :</label>
              <span v-if="trackInfo.osBrandName && trackInfo.osModelName">{{ trackInfo.osBrandName }} {{
                trackInfo.osModelName }}</span>
              <span v-else>{{ trackInfo.osCustomBrandModel }}</span>
            </div>

          </div>
        </div>
        <div class="image-section">
          <h4 class="section-title">
            <md-button class="md-info md-icon md-sm md-simple">
              <md-icon class="custom-icon">collections</md-icon>
            </md-button>
            Hadisə şəkilləri
          </h4>
          <stage-image :type="1" :images="files" />
        </div>
        <div class="info-section">
          <h4 class="section-title">
            <md-button class="md-info md-icon md-sm md-simple">
              <md-icon class="custom-icon">attach_money</md-icon>
            </md-button>
            Qiymətləndirmə
          </h4>


          <div class="info-item">
            <label>Qiymətləndirici A.S.A</label>
            <span>{{ trackInfo.techExpertUserName }}</span>
          </div>
          <div class="info-item">
            <label>Qiymətləndirici №</label>
            <a :href="`tel:${trackInfo.techExpertPhone}`" class="phone-number">{{ trackInfo.techExpertPhone }}</a>
          </div>
          <div class="info-item">
            <label>Təyin olunan məbləğ</label>
            <span class="price">{{ trackInfo.paymentSum }} </span>
            <!-- <span class="price">200 AZN</span> -->
          </div>
        </div>
        <div class="image-section">
          <h4 class="section-title">
            <md-button class="md-info md-icon md-sm md-simple">
              <md-icon class="custom-icon">description</md-icon>
            </md-button>
            Hadisəyə aid sənədlər
          </h4>
          <stage-image :type="2" :otherFiles="otherFiles" />
        </div>
        <div class="timeline-section">
          <h4 class="section-title">
            <md-button class="md-info md-icon md-sm md-simple">
              <md-icon class="custom-icon">timeline</md-icon>
            </md-button>
            Statuslar
          </h4>
          <div class="timeline">
            <div class="timeline-item" v-for="(activity, index) in timelineItems" :key="index"
              :class="{ 'timeline-warning': index === timelineItems.length - 1 }">
              <div class="timeline-icon"></div>
              <div class="timeline-content">
                <div class="timeline-date">{{ activity.statusDateStr }}</div>
                <div class="timeline-status">{{ activity.finishStatus }}</div>
              </div>
            </div>
          </div>
          <div v-if="trackInfo.assessmentStatus==2" class="button-container">
            <button class="status-button" onclick="window.location.href='YOUR_LINK_HERE'">
              Təmir prosesini izlə
            </button>
          </div>
        </div>
        <div class="footer">
          <a href="https://huestimates.com" target="_blank">
            <div class="powered-by">
              <h4 class="md-title">
                <span class="powered-by-text">Progress IMS Claims</span>
                <img src="../assets/img/logo2.png" class="logo" />
              </h4>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseStorageUrl } from "../services/helper";
import ProgressLabel from "../views/components/ProgressLabel.vue";
import Plate from "../views/components/Plate";
import StageImage from "../views/components/StageImage";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { GetTrackingInfo, GetTrackingStatus } from "../services/tracking";
import { GetTrackFiles, GetTrackDocs } from "../services/files"
import { DateTimeReverseToString } from "../services/helper";

export default {
  components: {
    Loading,
    Plate,
    ProgressLabel,
    StageImage
  },
  props: {
    linkid: String,
  },
  data() {
    return {
      isLoading: false,
      files: [],
      status: 1,
      timelineItems: [],
      compulsoryPeriod: '',
      voluntaryPeriod: '',
      compulsoryStatus: '',
      voluntaryStatus: '',
      trackInfo: {},
      claimId: null,
      otherFiles: []
    };
  },
  methods: {
    formatPlateNumber(plateNumber) {
      if (plateNumber && plateNumber.length >= 7) {
        return `${plateNumber.slice(0, 2)}-${plateNumber.slice(2, 4)}-${plateNumber.slice(4)}`;
      }
      return plateNumber;
    },
    mapsSelector() {
      const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.trackInfo.place)}`;
      const mapsUrl = navigator.platform.includes("iPhone") || navigator.platform.includes("iPad") || navigator.platform.includes("iPod")
        ? `maps:${url}`
        : url;
      window.open(mapsUrl);
    },

    getFiles() {
      GetTrackFiles(1, this.trackInfo.accidentId).then((response) => {
        if (response.data) {
          this.files = response.data;
          this.files.forEach((item) => {
            const year = new Date(item.createDate).getFullYear();
            item.url = `${baseStorageUrl}${year}/${item.fileName}`;
          });
        }
      });
      GetTrackDocs(3, this.trackInfo.claimId).then((response) => {
        if (response.data) {
          this.otherFiles = response.data;
          this.otherFiles.forEach((item) => {
            const year = new Date(item.createDate).getFullYear();
            item.url = `${baseStorageUrl}${year}/${item.fileName}`;
          });
        }
      });
    },
    fetchTrackingStatus() {
      this.isLoading = true;
      GetTrackingStatus(this.claimId)
        .then(response => {
          this.timelineItems = response.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    fetchTrackingInfo() {
      this.isLoading = true;
      GetTrackingInfo(this.linkid)
        .then((response) => {
          if (response.data) {
            console.log(response.data)
            this.trackInfo = response.data;
            this.trackInfo.callDate = DateTimeReverseToString(this.trackInfo.callDate);
            this.trackInfo.accidentDate = DateTimeReverseToString(this.trackInfo.accidentDate);
            if (this.trackInfo.startDate != null && this.trackInfo.endDate != null) {
              this.trackInfo.startDate = DateTimeReverseToString(this.trackInfo.startDate);
              this.trackInfo.endDate = DateTimeReverseToString(this.trackInfo.endDate);
            }
            if (this.trackInfo.volStartDate && this.trackInfo.volEndDate) {
              this.trackInfo.volStartDate = DateTimeReverseToString(this.trackInfo.volStartDate);
              this.trackInfo.volEndDate = DateTimeReverseToString(this.trackInfo.volEndDate);
            }

            this.compulsoryPeriod = this.trackInfo.startDate + "-" + this.trackInfo.endDate;
            this.voluntaryPeriod = this.trackInfo.volStartDate + "-" + this.trackInfo.volEndDate;
            this.claimId = this.trackInfo.claimId;

            this.getFiles();
            this.fetchTrackingStatus();

            this.status = 0;
          } else {
            this.status = 3;
          }
        })
        .catch(() => {
          console.error('Error fetching tracking info');
          this.status = 2;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    claimId(newClaimId) {
      if (newClaimId) {
        this.fetchTrackingStatus();
        this.getFiles();
      }
    },
    'trackInfo.accidentId'(newAccidentId) {
      if (newAccidentId && newAccidentId !== 0) {
        this.getFiles();
      }
    }

  },
  mounted() {
    this.fetchTrackingInfo();
  }
};
</script>

<style lang="scss" scoped>
.custom-icon {
  position: relative;
  top: -2px;
  /* Yukarıya kaldırma */
  left: -5px;
  /* Sola kaydırma */
}

.button-container {
  margin-top: 20px;
  /* Timeline'ın altına biraz boşluk bırak */
  text-align: center;
  /* Butonu ortalar */
}


.status-button {
  padding: 12px 24px;
  /* Butonun içindeki boşluk */
  font-size: 16px;
  /* Yazı boyutu */
  font-weight: 600;
  /* Yazı kalınlığı */
  color: #fff;
  /* Yazı rengi */
  background-color: #007bff;
  /* Buton arka plan rengi */
  border: none;
  border-radius: 5px;
  /* Köşe yuvarlama */
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.status-button:hover {
  background-color: #0056b3;
  /* Hover rengi */
  transform: scale(1.05);
  /* Hover efekti */
}

.phone-number {
  font-size: 16px;
  color: #0066cc; // Link rengi
  text-decoration: none; // Alt çizgi yok
  transition: color 0.3s ease; // Renk değişimi için geçiş efekti
}

.phone-number:hover {
  color: #004d99; // Üzerine gelindiğinde renk değişimi
}

.info-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 35%;
}

.btn-maps,
.btn-maps:hover,
.btn-maps:focus {
  margin-left: 10px;
  background-color: #00bcd4 !important;
  height: 25px !important;
  width: 20px !important;
}

.info-text {
  font-size: 16px;
  color: #333;
}


.car-info {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}


.car-info .section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.car-info h6 {
  margin: 5px 0;
}

.car-info .plate-container {
  text-align: center;
  margin-bottom: 20px;
}

.car-info .details-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.car-info .details-container .info-item {
  display: flex;
  flex-direction: column;
}

.car-info .details-container .info-item h6:first-child {
  font-weight: bold;
}

.wrapper {
  background: #f0f2f5;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.header {
  text-align: center;
  margin-bottom: 20px;
}

.title {
  font-size: 24px;
  color: #333;
  font-weight: 700;
}

.info-section {
  display: flex;
  flex-direction: column;
  /* Başlık ve bilgi öğeleri dikey olarak hizalanır */
  background: #ffffff;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.info-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: #ffffff;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  gap: 5px;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-item label {
  font-size: 14px;
  font-weight: 600;
  color: #555;
}

.info-item span {
  display: block;
  margin-top: 5px;
  font-size: 16px;
  color: #333;
}

.info-section .section-title {
  grid-column: span 4;
  font-size: 18px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .info-section {
    grid-template-columns: 1fr;
    /* Tek sütunlu düzen */
  }

  .info-section .section-title {
    grid-column: span 1;
  }
}

.car-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
}

.car-info {
  background: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  flex: 1;
  margin-right: 10px;
  margin-bottom: 20px;
}

.car-info:last-child {
  margin-right: 0;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}

.image-section {
  background: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}

.timeline-section {
  background: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}

.timeline {
  position: relative;
  padding-left: 20px;
}

.timeline-item {
  position: relative;
  margin-bottom: 20px;
  padding-left: 20px;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  background: #009688;
  border-radius: 50%;
}

.timeline-content {
  padding-left: 20px;
}

.timeline-date {
  font-size: 14px;
  font-weight: 600;
  color: #555;
}

.timeline-status {
  font-size: 16px;
  font-weight: 700;
  color: #009688;
}

.timeline-description {
  margin-top: 5px;
  font-size: 14px;
  color: #333;
}

.timeline-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 4px;
  height: 110%;
  width: 2px;
  background-color: #009688;
}

.timeline-item.timeline-warning::before {
  background-color: #f39c12;
  /* Warning color for the line */
}

.timeline-item.timeline-warning .timeline-icon {
  background: #f39c12;
  /* Warning color for the icon */
}

.timeline-item.timeline-warning .timeline-status {
  color: #f39c12;
  /* Warning color for the status */
}

.footer {
  text-align: center;
  margin-top: 20px;
}

.powered-by-text {
  font-size: 10px;
  color: #333;
  font-weight: 100;
}

.logo {
  width: 100px;
  margin-left: 10px;
}

@media (max-width: 768px) {
  .info-section {
    flex-direction: column;
  }

  .car-section {
    flex-direction: column;
  }

  .car-info {
    margin-right: 0;
  }
}
</style>
